import Vue from 'vue';
import { Puzzle } from 'js/crossword/Puzzle';
import BoardCell from "./BoardCell";

export default Vue.extend({
  props: {
    puzzle: Puzzle,
  },
  computed: {
    boardGridLayout(): string {
      return `
        grid-template-columns: repeat(${this.puzzle.data.columns}, 1fr);
        grid-template-rows: repeat(${this.puzzle.data.rows}, 1fr);
      `;
    },
  },
  methods: {
    resize(width: number, height: number) {
      this.$refs.boardContainer.style.width = `${width}px`;
      this.$refs.boardContainer.style.height = `${height}px`;
    },
  },
  render() {
    const { cells } = this.puzzle.data;
    return(
      <div class='board board--print' ref='boardContainer' style={this.boardGridLayout}>
        {cells.map((cell) => (
          <BoardCell
            cell={cell}
            key={cell.id}
            print={true}
          />
        ))}  
      </div>
    );
  },
});
